// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"543":"32df7031","726":"c7f09c4a"}[chunkId] + ".chunk.js";
};